export const ORB_THEMES = {
  aurora: {
    label: "Aurora boreale", swatch: ["#10B981", "#22D3EE", "#8B5CF6"],
    ribbons: [["#10B981", "#22D3EE"], ["#06B6D4", "#8B5CF6"], ["#8B5CF6", "#10B981"], ["#34D399", "#3B82F6"], ["#A78BFA", "#FBBF24"], ["#2DD4BF", "#A78BFA"]],
    core0: "45,212,191", core1: "59,130,246", accent: "251,191,36", tick: "34,211,238", arc: "45,212,191", ring: "139,92,246",
    waves: ["251,191,36", "34,211,238", "167,139,250"], part: ["251,191,36", "167,243,208"],
  },
  stark: {
    label: "Stark · rosso e oro", swatch: ["#DC2626", "#F59E0B", "#FDE68A"],
    ribbons: [["#DC2626", "#F59E0B"], ["#B91C1C", "#FBBF24"], ["#F97316", "#DC2626"], ["#FDE68A", "#EF4444"], ["#F59E0B", "#FCD34D"], ["#EF4444", "#FB923C"]],
    core0: "251,191,36", core1: "220,38,38", accent: "254,240,138", tick: "248,113,113", arc: "251,191,36", ring: "220,38,38",
    waves: ["254,240,138", "248,113,113", "251,146,60"], part: ["254,240,138", "252,165,165"],
  },
  arc: {
    label: "Reattore Arc · blu ghiaccio", swatch: ["#E0F2FE", "#38BDF8", "#1D4ED8"],
    ribbons: [["#E0F2FE", "#38BDF8"], ["#38BDF8", "#1D4ED8"], ["#7DD3FC", "#E0F2FE"], ["#0EA5E9", "#6366F1"], ["#BAE6FD", "#3B82F6"], ["#22D3EE", "#E0F2FE"]],
    core0: "186,230,253", core1: "29,78,216", accent: "255,255,255", tick: "125,211,252", arc: "56,189,248", ring: "99,102,241",
    waves: ["255,255,255", "56,189,248", "99,102,241"], part: ["255,255,255", "186,230,253"],
  },
  vibranium: {
    label: "Vibranio · viola e argento", swatch: ["#7C3AED", "#C4B5FD", "#E2E8F0"],
    ribbons: [["#7C3AED", "#C4B5FD"], ["#A855F7", "#E2E8F0"], ["#6D28D9", "#F0ABFC"], ["#C084FC", "#94A3B8"], ["#DDD6FE", "#8B5CF6"], ["#E879F9", "#A78BFA"]],
    core0: "196,181,253", core1: "109,40,217", accent: "226,232,240", tick: "196,181,253", arc: "168,85,247", ring: "232,121,249",
    waves: ["226,232,240", "192,132,252", "232,121,249"], part: ["226,232,240", "221,214,254"],
  },
  gamma: {
    label: "Gamma · verde energia", swatch: ["#22C55E", "#A3E635", "#7C3AED"],
    ribbons: [["#22C55E", "#A3E635"], ["#16A34A", "#7C3AED"], ["#84CC16", "#22C55E"], ["#4ADE80", "#A855F7"], ["#BEF264", "#15803D"], ["#86EFAC", "#8B5CF6"]],
    core0: "74,222,128", core1: "124,58,237", accent: "190,242,100", tick: "134,239,172", arc: "34,197,94", ring: "168,85,247",
    waves: ["190,242,100", "74,222,128", "168,85,247"], part: ["190,242,100", "187,247,208"],
  },
};
